module.exports = __webpack_public_path__ + "img/orange_020.4b61d707.png";